import img404 from "../../assets/images/error/404.svg";

const errorContentArabic = {
    backToHome: {
        link: '/',
        btnClass: 'btn btn-icon btn-primary',
        icon: 'arrow-left',
    },
    image: {
        src: img404,
        alt: 'خطأ 404',
    },
    title: 'Oh ! no',
    description: 'الصفحة غير موجودة',
    goHomeBtn: {
        link: '/',
        btnClass: 'btn btn-primary',
        text: 'الذهاب الى الرئيسية',
    },
};

export { errorContentArabic }